export default "__VITE_ASSET__qI_Yjm_6__"